import { styles } from './Conversations.styles';

export const ConversationsLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[128px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="h-[28px] w-[192px] animate-pulse rounded bg-grey-25" />
			<div className="h-[48px] animate-pulse rounded bg-grey-25" />
			{['a', 'b', 'c', 'd', 'e', 'f'].map((k) => (
				<div key={`row-${k}`} className="h-[40px] animate-pulse rounded bg-grey-25" />
			))}
		</main>
	</>
);
